/* eslint-disable @fx-ui/jdy-design/custom-color-disallowed-list */
import COLOR from '@fx-ui/color';

/**
 * 项目中与功能相关的颜色，允许按照业务新增
 */
export const FUNC_COLOR = {
    // 进度条颜色
    PROGRESS: COLOR.teal6,
    // 状态颜色
    INFO: COLOR.blue6,
    WARNING: COLOR.yellow6,
    ERROR: COLOR.red6,
    // Tooltip提示按钮颜色
    TOOLTIP_ICON: COLOR.grey7
};
